<div class="gray-bg-rounded mt-4">
  <div class="d-flex justify-content-between mb-2">
    <h3 class="mb-0">Select Additional Recipients</h3>

    <div class="d-flex gap-2">
      <a class="link" (click)="addTO()"><i class="pi pi-plus"></i> Add: To</a>

      <a class="link" (click)="addCC()"><i class="pi pi-plus"></i> Add: CC</a>
    </div>
  </div>

  <p-table
    #dt
    stripedRows
    [value]="contactsList"
    [(selection)]="contactsSelected"
    styleClass="p-datatable-customers order-listing"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="id"
    editMode="row"
    selectionMode="multiple"
    [scrollable]="true"
    styleClass="table-listing popuptable"
    scrollHeight="330px">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th class="col-center" style="width: 3rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="name" pSortableColumn="locatorD365">
          Recipient
          <p-sortIcon field="locatorD365"></p-sortIcon>
        </th>
        <th class="vaccount" pSortableColumn="descriptionD365">
          Display name
          <p-sortIcon field="descriptionD365"></p-sortIcon>
        </th>
        <th class="sname" pSortableColumn="purposeD365">
          Recipient type
          <p-sortIcon field="purposeD365"></p-sortIcon>
        </th>
        <th class="sname" pSortableColumn="isPrimaryD365">
          Primary
          <p-sortIcon field="isPrimaryD365"></p-sortIcon>
        </th>
      </tr>

      <tr>
        <th></th>
        <th>
          <div class="d-flex align-items-center">
            <input
              pInputText
              jniAutoCompleteBlocker
              id="locatorD365"
              name="locatorD365"
              pInputText
              type="text"
              (input)="
                dt.filter($any($event.target).value, 'locatorD365', 'contains')
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>

        <th>
          <div class="d-flex align-items-center">
            <input
              pInputText
              jniAutoCompleteBlocker
              id="descriptionD365"
              name="descriptionD365"
              pInputText
              type="text"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'descriptionD365',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>

        <th>
          <div class="d-flex align-items-center">
            <input
              pInputText
              jniAutoCompleteBlocker
              id="purposeD365"
              name="purposeD365"
              pInputText
              type="text"
              (input)="
                dt.filter($any($event.target).value, 'purposeD365', 'contains')
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th>

        <th>
          <div class="d-flex align-items-center">
            <input
              pInputText
              jniAutoCompleteBlocker
              id="isPrimaryD365"
              name="isPrimaryD365"
              pInputText
              type="text"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'isPrimaryD365',
                  'contains'
                )
              "
              placeholder=""
              class="p-column-filter" />
            <span class="pi pi-filter-icon pi-filter ms-2"></span>
          </div>
        </th></tr
    ></ng-template>
    <ng-template pTemplate="body" let-addressBookLists let-rowIndex="rowIndex">
      <tr class="p-selectable-row" [pSelectableRow]="addressBookLists">
        <td>
          <p-tableCheckbox
            [value]="addressBookLists"
            [pSelectableRow]="addressBookLists"></p-tableCheckbox>
        </td>
        <td>
          {{ addressBookLists.locatorD365 }}
        </td>
        <td>
          {{ addressBookLists.descriptionD365 }}
        </td>
        <td>
          {{ addressBookLists.purposeD365 }}
        </td>
        <td>
          {{ addressBookLists.isPrimaryD365 | titlecase }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No contacts found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
